export default "__VITE_ASSET__w9Ifxk5X__"